<template>
    <div class="case_home">
        <div class="case1">
            <img src="../img/case-banner.jpg" alt="">
        </div>
        
        <div class="case3">
            <div class="section_title">
                <p class="section_cn">成功案例</p>
                <p class="section_en">SUCCESSFUL CASE</p>
            </div>
            <div class="s34_cont">
                <div class="swiper mySwiper2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in selectedData">
                            <div class="s34item" v-for="(item2, index2) in item" @click="caseDetail(item2.id)">
                                <p class="s34_p1">RoSSo</p>
                                <img :src="'https://public.rossoarts.com/static/uploads/case/' + item2.portfolioShow"
                                    alt="">
                                <p class="s34_p2">{{ item2.name }}</p>
                                <p class="s34_p3">{{ item2.cname }}</p>
                                <p class="s34_p3">{{ item2.school | schoolSplit }}</p>
                            </div>

                        </div>




                    </div>
                    <!-- <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div> -->
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>

        <div class="case2">
            <div class="s1_right">

                <div class="s1_right_title">
                    <div class="s1_right_starBox">
                        <img src="../img/Star 1.png" alt="" class="star">
                        <h1>RoSSo 录取榜单</h1>
                        <img src="../img/Star 1.png" alt="" class="star">
                    </div>
                    <p class="s1_title_p">RoSSo OFFERLIST</p>

                </div>

                <div class="s1_banner_box">

                    <div class="swiper mySwiper1">
                        <div class="swiper-wrapper">

                            <!-- 循环体 -->
                            <div class="swiper-slide" v-for="item in schoolDataa">

                                <div @click="schoolDetail(item.x.id)">
                                    <!-- :src=item.school1.imgUrl -->
                                    <img :src="'https://public.rossoarts.com/static/uploads/' + item.x.logo" alt="">
                                    <p class="s1_cname">{{ item.x.cname }}</p>
                                    <p>录取<span>{{ item.x.admission_num }}</span>人</p>

                                </div>

                                <div @click="schoolDetail(item.y.id)">
                                    <img :src="'https://public.rossoarts.com/static/uploads/' + item.y.logo" alt="">
                                    <p class="s1_cname">{{ item.y.cname }}</p>
                                    <p>录取<span>{{ item.y.admission_num }}</span>人</p>
                                </div>

                            </div>


                        </div>
                        <!-- <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div> -->
                        <div class="swiper-pagination"></div>
                    </div>
                </div>



            </div>
        </div>
        <!--  -->
    </div>
</template>
<script>
import "@/assets/css/case.less"
import Swiper from 'swiper/bundle'
import 'swiper/css';
import "swiper/css/effect-flip";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import axios from "axios";

import { mapGetters, mapActions } from 'vuex';
export default {


    data() {
        return {
            schoolDataa: [],
            selectedData: [],
        }
    },
    created() {
        this.getSchool()
       
        this.getSelected()
    },
    filters: {
        schoolSplit(val) {
            // const valLength = val.split("/").length
            // return valLength<2?val.split("/")[0]:val.split("/")[0] +"/" + val.split("/")[1]
            return val.split("/")[0]
        },
        schoolAll(val) {
            return val.split(",")[0]
        },
    },
    methods: {
        
        
        
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        caseDetail(val) {
            this.$router.push(`/case/${val}.html`)
        },
        schoolDetail(val) {
            console.log(val);
            this.$router.push(`/schools/${val}.html`)
        },
        mySwiper2Init() {
            new Swiper(".mySwiper2", {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
            })
        },
        getSelected() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstCase?limit=24&page=1").then((data) => {
                // console.log(data.data);
                // console.log(this.arrGroup(data.data, 6));
                this.selectedData = this.arrGroup(data.data, 6)
               
                
                // console.log(selectedData,"0229999999999999");
                this.$nextTick(() => {
                    this.mySwiper2Init()
                })
            })
        },
        getSchool() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstOffer?limit=36&page=1").then((data) => {
                // console.log(data.data.data);
                const arr = data.data.data
                const res = [];
                for (let i = 0; i < arr.length - 1; i += 2) {
                    let index = Math.floor(i / 2);
                    const obj = {
                        x: arr[i],
                        y: arr[i + 1],
                        z: i
                    };
                    res[index] = obj;
                }
                // console.log("res school", res);

                this.schoolDataa = res

            })
        },
        mySwiper1Init() {
            new Swiper('.mySwiper1', {
                clickable: true,
                slidesPerView: 4,
                spaceBetween: 30,
                slidesPerGroup: 3,
                observer: true,
                loop: true,
                autoplay: {
                    delay: 10000,
                    disableOnInteraction: false,
                },
                loopFillGroupWithBlank: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

            })
        },
    },
    mounted() {
        this.mySwiper1Init()
    }
}
</script>